var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2187 7.90879L16.8071 14.448C16.7042 16.0788 15.8333 17.4167 13.6483 17.4167H5.35167C3.16667 17.4167 2.28792 16.0788 2.19292 14.448L1.78125 7.90879C1.67042 6.19879 3.03208 4.75004 4.75 4.75004C5.23292 4.75004 5.67625 4.47296 5.89792 4.04546L6.46792 2.89754C6.83208 2.17712 7.78208 1.58337 8.5975 1.58337H10.4104",
    stroke: "#0A49A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 6.33337H10.6875",
    stroke: "#0A49A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 14.25C10.9171 14.25 12.0729 13.0941 12.0729 11.677C12.0729 10.26 10.9171 9.10413 9.50001 9.10413C8.08293 9.10413 6.92709 10.26 6.92709 11.677C6.92709 13.0941 8.08293 14.25 9.50001 14.25Z",
    stroke: "#0A49A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 3.95837H16.8229",
    stroke: "#0A49A5",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6458 6.13542V1.78125",
    stroke: "#0A49A5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.c7565e27914e86f977a7a0a40475d518.svg";
export { ForwardRef as ReactComponent };